<template>
  <div class="warpper padding-sm bg-white">
    <div class="flex align-center justify-between">
      <div class="page-title line-height">常见问题</div>
      <div class="page-operate yellow" @click="addQuestion(false)">添加</div>
    </div>

      <empty v-if="lists.length === 0" :type="0"/>


    <div class="flex flex-direction">
      <div class="item flex flex-direction justify-center" v-for="(item,index) in lists" :key="index">
        <div class="tag-list flex flex-wrap align-center">
          关键词
          <div class="item-tag margin-left-sm" v-for="tag in item.key_word" :key="tag">
            {{ tag }}
          </div>
        </div>
        <div class="title flex align-center"><i class="iconfont icon-wenti"></i>{{ item.title }}</div>
        <div class="content">
          <i class="iconfont icon-wenda"></i>{{ item.content }}
        </div>
        <div class="item-operate">
          <i class="el-icon-edit" @click="addQuestion(item)"></i>
          <i class="el-icon-delete margin-left" @click="deleteItem(item.id)"></i>
        </div>
      </div>
    </div>
      <el-pagination
          v-if="lists.length>0"
          :current-page.sync="page"
          :page-size="limit"
          :total="total"
          background
          class="page-all margin-top"
          layout="prev, pager, next, jumper"
          @current-change="init">
      </el-pagination>
    <add-question-dialog :applyDialogVisible="applyDialogVisible" :id="cur_id" :info="cur_item"
                         @watchState="watchState"></add-question-dialog>
  </div>
</template>

<script>
import {getQuestionList, delQuestion} from '@/api/organiz'
import AddQuestionDialog from "@/components/AddQuestionDialog.vue";

export default {
  name: "question",
  data() {
    return {
      lists: [],
      page: 1,
      limit: 10,
      total: 0,
      cur_item: null,
      cur_id: 0,
      applyDialogVisible: false,
      noData: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.$emit('setIndex', [6, 1], '常见问题')
    this.init()
  },

  components: {AddQuestionDialog},
  methods: {
    //  页面加载时请求
    async init() {
      let _data = await getQuestionList(this.page, this.limit, '')
      if (_data.status === 200) {
        _data.data.map(item => {
          item.key_word = item.key_word ? item.key_word.split('/') : []
        })
        this.lists = _data.data
        this.total = _data.count
        _data.data.length>0?this.noData = false : this.noData = true
      } else {
          this.lists = []
          this.total = 0
        this.noData = true
      }
    },
    addQuestion(data) {
      this.applyDialogVisible = true
      if (data) {
        this.cur_item = JSON.parse(JSON.stringify(data))
        this.cur_id = data.id
      } else {
        this.cur_item = null
        this.cur_id = 0
      }
    },
    deleteItem(id) {
      this.$confirm("确定要删除此常见问题吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delQuestion(id)
      })
    },
    async delQuestion(id) {
      let _data = await delQuestion(id)
      if (_data.status === 200) {
        this.init()
        this.$message.success(_data.msg)
      }
    },
    watchState(state) {
      if (state) this.init()
      this.applyDialogVisible = false;
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.warpper {
  .item {
    width: 100%;
    min-height: 220px;
    background-color: #ffffff;
      box-shadow: 0 0 10px #666666;
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;

    .item-operate {
      display: none;
    }

    &:hover {
      position: relative;
      cursor: pointer;

      .item-operate {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #00000033;
          border-radius: 10px;
        i {
          width: 80px;
          height: 80px;
          line-height: 80px;
          border-radius: 80px;
          text-align: center;
          background: #ffffff;
          color: #ed7d31;
          font-size: 28px;
          cursor: pointer;
        }
      }
    }

    .tag-list {
      font-size: 12px;
      color: #666666;

      .item-tag {
        height: 23px;
        line-height: 23px;
        border-radius: 12px;
        border: solid 1px #dae0e6;
        font-size: 12px;
        color: #666666;
        padding: 0 12px;
      }
    }

    .title {
      min-height: 55px;
      background-color: #f3f7fb;
      border-radius: 10px;
      border: solid 1px #dae0e6;
      font-size: 18px;
      font-weight: bold;
      padding: 20px;
      color: #333333;
      margin-top: 10px;

      i {
        font-size: 17px;
        color: #0a2240;
        margin-right: 12px;
      }
    }

    .content {
      width: 100%;
      background-color: #ffffff;
      border-radius: 10px;
      border: solid 1px #dae0e6;
      font-size: 16px;
      line-height: 26px;
      color: #6666;
      margin-top: 10px;
      padding: 20px;

      i {
        font-size: 15px;
        color: #ffb400;
        margin-right: 12px;
      }
    }
  }
}
</style>